import axios from "axios";
import React, { useRef, useState } from "react";
import { CgClose } from "react-icons/cg";
import { toast } from "react-toastify";
import useAuthContext from "../../../hooks/useAuthContext";
import InputFieldLarge from "../../../Shared Components/InputFieldLarge";
import StaticDropdown from "../../../Shared Components/StaticDropdown";
import UpdationDetails from "../../../Shared Components/UpdationDetails";
import {
  authFormHeader,
  MASTER_SALON_USER,
  USER_ADD,
  USER_UPDATE,
} from "../../../utils/Constants";
import { useFormik } from "formik";
import { userSchema } from "../../../utils/validationschema";
import InputError from "../../../Shared Components/InputError";
import SubmitButton from "../../../Shared Components/SubmitButton";
import useLoading from "../../../hooks/useLoading";
import DynamicDropdown from "../Coupon Form/DynamicDropdown";

const UserForm = ({ state, setState, apiCall, data }) => {
  const initialValues = {
    name: state?.data?.name ?? "",
    mobile: state?.data?.mobile ? state?.data?.mobile : state?.mobile,
    email: state?.data?.email ?? "",
    statusName: state?.data?.status === 1 ? "Enabled" : "Disabled",
    image: "",
    role: state?.data?.role ?? "",
    salon: state?.data?.salon
      ? `${state?.data?.salon?.salonId}_${state?.data?.salon?.name}`
      : "",
    isDataComing: state?.data ? true : false,
  };
  const [oldImagePath, setoldImagePath] = useState("null");

  const [salonId, setSalonId] = useState(state?.data?.salon?._id ?? "");

  const formik = useFormik({
    initialValues,
    validationSchema: userSchema,
    onSubmit: (data) => {
      formSubmit(data);
    },
  });

  const setPositionToBody = () => {
    setState({
      ...state,
      modal: false,
      check: "",
      step: 0,
    });
    document.body.style.overflow = "unset";
  };

  const customerImage = useRef(null);
  const handleSingleImg = (e) => {
    e.preventDefault();
    customerImage.current.click();
  };

  const [singleImage, setSingleImage] = useState(
    state?.data?.image
      ? `${process.env.REACT_APP_Image_BaseURL}${state?.data?.image}`
      : ""
  );
  const imageDataURL = (e) => {
    if (e.target.files && e.target.files[0]) {
      setSingleImage(URL.createObjectURL(e.target.files[0]));
      formik.setFieldValue("image", Array.from(e.target.files));
    }
  };
  const deleteImage = (index) => {
    if (index === -1) {
      formik.setFieldValue("image", "");
      setSingleImage("");
      setoldImagePath(state?.data?.image ? state?.data?.image : null);
      customerImage.current.value = "";
    }
  };

  const { token } = useAuthContext();
  const [loader, showLoader, hideLoader] = useLoading();

  const formSubmit = async (data) => {
    console.log("form submit called");

    //form data
    const sFormData = new FormData();
    sFormData.append("name", data.name);
    sFormData.append("image", data.image[0]);
    sFormData.append("mobile", data.mobile);
    sFormData.append("email", data.email);
    sFormData.append("status", data.statusName === "Enabled" ? 1 : 0);
    sFormData.append("role", data.role.toLowerCase());

    if (data.role === MASTER_SALON_USER) {
      sFormData.append("salon", salonId);
    }

    if (state.data) {
      sFormData.append("updateImage", oldImagePath);
    }

    if (token) {
      if (state.data === undefined) {
        try {
          showLoader();
          const res = await axios.post(`${USER_ADD}`, sFormData, {
            //headers: authFormHeader,
            headers: {
              "Content-type": "multipart/form-data",
              Authorization: "Bearer " + token,
              "X-Requested-With": "XMLHttpRequest",
            },
          });

          if (res.status === 200) {
            setPositionToBody();
            apiCall();
            hideLoader();
            toast.success("User Added", {
              position: "bottom-center",
              autoClose: 1000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
            });
          } else {
            console.log("else error: ", res.status);
          }
        } catch (error) {
          console.log("catch error: ", error);
          if (error?.response?.status === 502) {
            hideLoader();
            toast.error(error?.response?.data?.message, {
              position: "bottom-center",
              autoClose: 1000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
            });
          }
        }
      } else {
        try {
          showLoader();
          console.log("update api called");
          const res = await axios.put(
            `${USER_UPDATE}${state?.data?._id}/form`,
            sFormData,
            {
              //headers: authFormHeader,
              headers: {
                "Content-type": "multipart/form-data",
                Authorization: "Bearer " + token,
                "X-Requested-With": "XMLHttpRequest",
              },
            }
          );

          if (res.status === 200) {
            setPositionToBody();
            apiCall();
            hideLoader();
            toast.success("User Updated", {
              position: "bottom-center",
              autoClose: 1000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
            });
          } else {
            console.log("else error: ", res.status);
          }
        } catch (error) {
          console.log("catch error: ", error);
          if (error.response.status === 502) {
            hideLoader();
            toast.error(error?.response?.data?.message, {
              position: "bottom-center",
              autoClose: 1000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
            });
          }
        }
      }
    }
  };

  return (
    <>
      <div
        className={
          state.modal ? "formWrapper formWrapper-active" : "formWrapper"
        }
      >
        <div className="formDiv"></div>
        <div className="formContainer">
          <div className="formHeadingDiv">
            <h1 className="font22x500 mb-0">
              {!state.data ? "New User" : "Edit User"}
            </h1>
            <span onClick={setPositionToBody}>
              <CgClose />
            </span>
          </div>
          <div className="formContent">
            <form onSubmit={formik.handleSubmit} encType="multipart/form-data">
              {/* name* */}
              <div className="mb-3">
                <InputFieldLarge
                  label="Name*"
                  htmlFor="name"
                  type="text"
                  name="name"
                  stateData={formik.values.name}
                  setStateData={formik.handleChange}
                />
                {formik.errors.name ? (
                  <InputError error={formik.errors.name} />
                ) : null}
              </div>

              {/* customer image */}
              <div className="mb-3">
                <div className="mb-0">
                  <label
                    htmlFor="formFile"
                    className="font12x500 mb-1 form-label"
                  >
                    Image
                  </label>
                  <input
                    ref={customerImage}
                    className="form-control shadow-none"
                    type="file"
                    id="formFile"
                    name="image"
                    accept={".png, .jpg, .jpeg"}
                    hidden
                    onChange={(e) => {
                      imageDataURL(e);
                    }}
                  />
                </div>
                <div className="uploadImg d-flex align-items-center mb-2">
                  <div
                    className="uploadBtn font12x400 me-3"
                    onClick={(e) => {
                      handleSingleImg(e);
                    }}
                  >
                    Upload
                  </div>
                  <span className="font12x400">
                    Allowed file types: jpg, jpeg, png
                  </span>
                </div>
                {singleImage && (
                  <div className="imageWrapper">
                    <img
                      src={singleImage}
                      alt="delete"
                      width={61}
                      height={61}
                    />
                    <div
                      className="deleteDiv"
                      onClick={() => {
                        deleteImage(-1);
                      }}
                    >
                      <img src="/Assets/delete.svg" alt="delete" />
                    </div>
                  </div>
                )}
                {formik.errors.image ? (
                  <InputError error={formik.errors.image} />
                ) : null}
              </div>

              {/* number* */}
              <div className="mb-3">
                <InputFieldLarge
                  label="Mobile Number*"
                  htmlFor="number"
                  type="tel"
                  name="mobile"
                  stateData={formik.values.mobile}
                  setStateData={formik.handleChange}
                />
                {formik.errors.mobile ? (
                  <InputError error={formik.errors.mobile} />
                ) : null}
              </div>

              {/* Email Id* */}
              <div className="mb-3">
                <InputFieldLarge
                  label="Email Id*"
                  htmlFor="email"
                  type="email"
                  name="email"
                  stateData={formik.values.email}
                  setStateData={formik.handleChange}
                />
                {formik.errors.email ? (
                  <InputError error={formik.errors.email} />
                ) : null}
              </div>

              {/* status */}
              <div className="mb-3">
                <StaticDropdown
                  data={[
                    { value: "Enabled", label: "Enabled" },
                    { value: "Disabled", label: "Disabled" },
                  ]}
                  label="Status*"
                  htmlFor="status"
                  type="text"
                  placeholder="Select Status"
                  name="statusName"
                  stateData={formik.values.statusName}
                  setStateData={(e) => {
                    formik.setFieldValue("statusName", e);
                  }}
                />
                {formik.errors.statusName ? (
                  <InputError error={formik.errors.statusName} />
                ) : null}
              </div>

              {!state.data ? (
                <>
                  <div className="mb-3">
                    <StaticDropdown
                      data={[
                        { value: "admin", label: "admin" },
                        { value: "end-user", label: "end-user" },
                        { value: "salon-user", label: "salon-user" },
                      ]}
                      label="Role*"
                      htmlFor="role"
                      type="text"
                      placeholder="Select role"
                      name="role"
                      stateData={formik.values.role}
                      setStateData={(e) => {
                        formik.setFieldValue("role", e);
                      }}
                    />
                    {formik.errors.role ? (
                      <InputError error={formik.errors.role} />
                    ) : null}
                  </div>

                  {/* salon list */}
                  {formik.values.role === MASTER_SALON_USER && (
                    <div className="mb-3">
                      <DynamicDropdown
                        data={data}
                        setSalonId={setSalonId}
                        label="Salon*"
                        htmlFor="salon"
                        type="text"
                        name="salon"
                        placeholder="Select Salon"
                        stateData={formik.values.salon}
                        setStateData={(e) => {
                          formik.setFieldValue("salon", e);
                        }}
                      />
                      {formik.errors.salon ? (
                        <InputError error={formik.errors.salon} />
                      ) : null}
                    </div>
                  )}
                </>
              ) : (
                <>
                  <div className="mb-3">
                    <InputFieldLarge
                      label="Role*"
                      htmlFor="role"
                      type="text"
                      name="role"
                      stateData={formik.values.role}
                      readOnly={true}
                    />
                  </div>
                  <div className="mb-3">
                    <InputFieldLarge
                      label="Salon*"
                      htmlFor="salon"
                      type="text"
                      name="salon"
                      stateData={formik.values.salon}
                      readOnly={true}
                    />
                  </div>
                </>
              )}

              <SubmitButton
                data={!state.data}
                loader={loader}
                create="Create Id"
                update="Update Id"
              />
            </form>

            {state?.data && <UpdationDetails data={state?.data} />}
          </div>
        </div>
      </div>
    </>
  );
};

export default UserForm;
